import {
  ApolloClient,
  ApolloLink,
  HttpLink,
  InMemoryCache,
  from,
} from "@apollo/client";
import { setContext } from "@apollo/client/link/context";
import { onError } from "@apollo/client/link/error";
import { RestLink } from "apollo-link-rest";

import { auth } from "@/firebase";
import { authenticationStateVar } from "@/apollo/auth-state";
import { env } from "@/lib/env";

const httpLink = new HttpLink({
  uri: env.skedLinkBackendApiUrl,
});

const restLink = new RestLink({
  uri: env.schedugramServerBackendUrl || "http://localhost:3000",
}) as unknown as ApolloLink;

const authLink = setContext(async (_, { headers }) => {
  const nextHeaders: Record<string, string> = { ...(headers ?? {}) };
  if (auth.currentUser) {
    try {
      const token = await auth.currentUser.getIdToken();
      if (token) {
        nextHeaders.Authorization = `Bearer ${token}`;
      }
    } catch (error) {
      console.error("Failed to fetch firebase id token", error);
    }
  }
  return { headers: nextHeaders };
});

const errorLink = onError(({ graphQLErrors }) => {
  if (!graphQLErrors) return;
  for (const { message } of graphQLErrors) {
    if (message.includes("Not authenticated")) {
      void auth.signOut();
      return;
    }
  }
});

const cache = new InMemoryCache({
  typePolicies: {
    Query: {
      fields: {
        authenticationState: {
          read() {
            return authenticationStateVar();
          },
        },
      },
    },
  },
});

export const apolloClient = new ApolloClient({
  cache,
  link: from([authLink, errorLink, restLink, httpLink]),
});
